<template>
  <div
    :id="viewerId"
    class="relative viewer-osd w-full"
  >
    <loading
      v-model:active="loading"
      :is-full-page="false"
      :opacity="0"
    />
    <slot />
    <div id="toolbarOSD">
      <div class="controlOSD zoomOSD">
        <button
          id="label-zoomInOSD"
          v-tooltip.left="$t('layout.navigation.zoomIn')"
          class="btn btn__tools"
        >
          <IconWrap label="zoomInOSD">
            <IconPlus />
          </IconWrap>
        </button>
        <button
          id="label-zoomOutOSD"
          v-tooltip.left="$t('layout.navigation.zoomOut')"
          class="btn btn__tools"
        >
          <IconWrap label="zoomOutOSD">
            <IconMinus />
          </IconWrap>
        </button>
      </div>
      <div class="controlOSD">
        <button
          id="label-fullscreenOSD"
          v-tooltip.left="$t('layout.navigation.fullscreen')"
          class="btn btn__tools"
        >
          <IconWrap label="fullscreenOSD">
            <IconFullscreen />
          </IconWrap>
        </button>
      </div>
      <slot name="control" />
    </div>
  </div>
</template>

<script>
import IconFullscreen from '@/assets/images/icons/Fullscreen';
import IconMinus from '@/assets/images/icons/Minus';
import IconPlus from '@/assets/images/icons/Plus';
import IconWrap from '@/assets/images/icons';

import OpenSeadragon from 'openseadragon';

export default {
  name: 'Viewer2D',

  components: {
    IconWrap,
    IconFullscreen,
    IconPlus,
    IconMinus
  },

  props: {

    viewerId: {
      type: String,
      default: () => 'viewerOSD'
    },

  },

  emits: ['ready'],

  setup() {
    let unsubscribeLoadMeta = null;
    let viewer2D = null;

    return { unsubscribeLoadMeta, viewer2D };
  },

  data() {
    return {
      loading: undefined,
      imageRegionByPx: ''
    };
  },

  mounted() {
    // Remove title attributes
    OpenSeadragon.setString('Tooltips.ZoomIn', '');
    OpenSeadragon.setString('Tooltips.ZoomOut', '');
    OpenSeadragon.setString('Tooltips.FullPage', '');

    this.initSeadragon();
  },

  beforeUnmount() {
    if (this.unsubscribeLoadImage) this.unsubscribeLoadImage();
    if (this.viewer2D) this.viewer2D.destroy();
  },

  methods: {
    initSeadragon() {
      this.viewer2D = OpenSeadragon({
        id: this.viewerId,
        toolbar: 'toolbarOSD',
        zoomInButton: 'label-zoomInOSD',
        zoomOutButton: 'label-zoomOutOSD',
        fullPageButton: 'label-fullscreenOSD',
        showHomeControl: false,
        zoomPerClick: 1.2,
        animationTime: 0.8,
        preserveImageSizeOnResize: false,
        preserveOverlays: true
      });
      this.$emit('ready');

      this.viewer2D.addHandler('tile-loaded', () => {
        this.loading = undefined;
        if(this.imageRegionByPx) {
          //regionData(x, y, width, height)
          const [x,y,w,h] = this.imageRegionByPx;
          var tiledImage = this.viewer2D.world.getItemAt(0);
          tiledImage.setCroppingPolygons([
            [{ 'x':x,'y':y },{ 'x':x+w,'y':y },{ 'x':x+w,'y':y+h },{ 'x':x,'y':y+h }]
          ]);
          this.viewer2D.forceRedraw();
        }
      });
    },

    openImage(tileSources,regionByPx) {
      this.loading = true;
      this.imageRegionByPx = regionByPx ? regionByPx : '';
      this.viewer2D.open(tileSources);
    }
  }
};
</script>

<style lang="postcss">
/* Copy style from Map */
.viewer-osd {
  background-color: theme("colors.gray.100");
  @apply h-full;
}

.slider--open .viewer-osd {
  height: calc(100% - var(--sliderHeight));
}

#toolbarOSD {
  position: absolute !important;
  right: 0 !important;
  margin: 0.5rem !important;
  z-index: 50 !important;
  bottom: 0;
  transition: bottom 300ms cubic-bezier(0.4, 0, 0.2, 1);
  & .controlOSD {
    @apply mb-2;
  }
}

.slider--open #toolbarOSD {
  bottom: 50px;
}

.slider--close #toolbarOSD {
  bottom: 50px;
}

@media screen and (max-width: 800px) {
  .slider--open .viewer-osd {
    height: 100vw;
  }
}
</style>
